export const gonvarri = {
  gonvarri: {
    chapa: {
      quantity: {
        title: 'Por favor, especifique quantas chapas deseja por pacote',
        warning: 'O peso do pacote será de aproximadamente ',
        minText: 'Valor mínimo',
        maxText: 'Valor máximo'
      },
      raw: {
        title: 'Para Pacotes de Peso Elegível, por favor, especifique o peso máximo desejado por pacote (KG):',
        minText: 'O peso mínimo dos pacotes é de',
        maxText: 'O peso máximo dos pacotes é de'
      },
      ajustToStock: 'Ajuste ao stock disponível',
    },
    productSummary: {
      quantity: 'Quantidade',
      price: 'Preço'
    },
    quick: {
      inputs: {
        length: 'Comprimento (MM)',
        sheets: 'Chapas / Pacote',
        lengthwarning: 'Por favor, indique o comprimento desejado (mm):',
        minlenght: 'Valor mínimo: {{minLenght}} mm',
        weight: 'Peso do Balote (KG)',
        quantity: 'Número de Balotes',
        minWeight: 'Peso mín.',
        maxWeight: 'Peso máx.',
        packageWeight: 'Pacote de aprox.',
      },
      changeview: 'Para comprar por chapas',
      clickhere: 'clique aqui'
    },
    company: {
      addresses: {
        default: 'Definir como padrão'
      }
    },
    header: {
      company: {
        users: 'Usuários',
        addresses: 'Lista de Endereços'
      }
    },
    product: {
      notification: 'Avise-me quando estiver em stock',
      cancelNotification: 'Não me avise'
    }
  }
};
